const P = {
  real: "green.derivws.com",
  demo: "blue.derivws.com"
}, y = {
  "deriv.app": "16929",
  "app.deriv.com": "16929",
  "staging-app.deriv.com": "16303",
  "app.deriv.me": "1411",
  "staging-app.deriv.me": "1411",
  "app.deriv.be": "30767",
  "staging-app.deriv.be": "31186",
  "binary.com": "1",
  "test-app.deriv.com": "51072",
  "p2p.deriv.com": "61859",
  "staging-p2p.deriv.com": "62019"
}, _ = "deriv", Fe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appBrand: _,
  domainAppId: y,
  environments: P
}, Symbol.toStringTag, { value: "Module" })), L = {
  AAD: 2,
  AED: 2,
  AFN: 2,
  ALL: 2,
  AMD: 2,
  ANG: 2,
  AOA: 2,
  ARS: 2,
  AUD: 2,
  AWG: 2,
  AZN: 2,
  BAM: 2,
  BBD: 2,
  BCH: 8,
  BDT: 2,
  BGN: 2,
  BHD: 3,
  BIF: 0,
  BMD: 2,
  BND: 2,
  BOB: 2,
  BOV: 2,
  BRL: 2,
  BSD: 2,
  BTC: 8,
  BTN: 2,
  BUSD: 2,
  BWP: 2,
  BYN: 2,
  BZD: 2,
  CAD: 2,
  CDF: 2,
  CHE: 2,
  CHF: 2,
  CHW: 2,
  CLF: 4,
  CLP: 0,
  CNY: 2,
  COP: 2,
  COU: 2,
  CRC: 2,
  CUC: 2,
  CUP: 2,
  CVE: 2,
  CZK: 2,
  DAI: 2,
  DJF: 0,
  DKK: 2,
  DOP: 2,
  DZD: 2,
  EGP: 2,
  ERN: 2,
  ETB: 2,
  ETC: 8,
  ETH: 8,
  EUR: 2,
  EURS: 2,
  eUSDT: 2,
  FJD: 2,
  FKP: 2,
  GBP: 2,
  GEL: 2,
  GHS: 2,
  GIP: 2,
  GMD: 2,
  GNF: 0,
  GTQ: 2,
  GYD: 2,
  HKD: 2,
  HNL: 2,
  HRK: 2,
  HTG: 2,
  HUF: 2,
  IDK: 0,
  IDR: 2,
  ILS: 2,
  INR: 2,
  IQD: 3,
  IRR: 2,
  ISK: 0,
  JMD: 2,
  JOD: 3,
  JPY: 0,
  KES: 2,
  KGS: 2,
  KHR: 2,
  KMF: 0,
  KPW: 2,
  KRW: 0,
  KWD: 3,
  KYD: 2,
  KZT: 2,
  LAK: 2,
  LBP: 2,
  LKR: 2,
  LRD: 2,
  LSL: 2,
  LTC: 8,
  LYD: 3,
  MAD: 2,
  MDL: 2,
  MGA: 2,
  MKD: 2,
  MMK: 2,
  MNT: 2,
  MOP: 2,
  MRU: 2,
  MUR: 2,
  MVR: 2,
  MWK: 2,
  MXN: 2,
  MXV: 2,
  MYR: 2,
  MZN: 2,
  NAD: 2,
  NGN: 2,
  NIO: 2,
  NOK: 2,
  NPR: 2,
  NZD: 2,
  OMR: 3,
  PAB: 2,
  PAX: 2,
  PEN: 2,
  PGK: 2,
  PHP: 2,
  PKR: 2,
  PLN: 2,
  PYG: 0,
  QAR: 2,
  RON: 2,
  RSD: 2,
  RUB: 2,
  RWF: 0,
  SAR: 2,
  SBD: 2,
  SCR: 2,
  SDG: 2,
  SEK: 2,
  SGD: 2,
  SHP: 2,
  SLL: 2,
  SOS: 2,
  SRD: 2,
  SSP: 2,
  STN: 2,
  SVC: 2,
  SYP: 2,
  SZL: 2,
  THB: 2,
  TJS: 2,
  TMT: 2,
  TND: 3,
  TOP: 2,
  TRY: 2,
  TTD: 2,
  TUSD: 2,
  tUSDT: 2,
  TWD: 2,
  TZS: 2,
  UAH: 2,
  UGX: 0,
  USB: 2,
  USD: 2,
  USDC: 2,
  USDK: 2,
  UST: 2,
  USN: 2,
  UYI: 0,
  UYU: 2,
  UYW: 4,
  UZS: 2,
  VES: 2,
  VND: 0,
  VUV: 0,
  WST: 2,
  XAF: 0,
  XCD: 2,
  XOF: 0,
  XPF: 0,
  YER: 2,
  ZAR: 2,
  ZMW: 2,
  ZWL: 2
}, Ge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  precision: L
}, Symbol.toStringTag, { value: "Module" })), w = ["PNG", "JPG", "JPEG", "GIF", "PDF"], ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  supportedDocumentFormats: w
}, Symbol.toStringTag, { value: "Module" })), O = "client.active_loginid", x = "client.account_list", J = "client.verify_email", R = "config.app_id", T = "config.server_url", g = "i18n_language", k = "ui.theme", X = "ui.show_report_drawer", Q = "ui.expand_account_switcher", q = "trader.layout", ee = "should_not_show_auto_archive_message_again", te = "order_ids", re = "should_show_p2p_guide", Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accountList: x,
  activeLoginid: O,
  configAppId: R,
  configServerURL: T,
  i18nLanguage: g,
  lastVerifyEmail: J,
  p2pArchiveMessage: ee,
  p2pOrderIds: te,
  p2pShowGuide: re,
  traderLayout: q,
  uiExpandAccountSwitcher: Q,
  uiShowReportsDrawer: X,
  uiTheme: k
}, Symbol.toStringTag, { value: "Module" })), h = "deriv.com", N = "deriv.me", C = "deriv.be", U = [h, C, N], A = typeof window < "u" && window.location.hostname.split("app.")[1], i = U.includes(A) ? A : h, ne = `https://bot.${i}`, oe = `https://staging-bot.${i}`, ae = `https://app.${i}`, se = `https://staging-app.${i}`, M = `https://${i}`, E = `https://eu.${i}`, ie = `https://staging.${i}`, ce = i, de = `https://smarttrader.${i}`, le = `https://staging-smarttrader.${i}`, ue = `https://p2p.${i}`, me = `https://staging-p2p.${i}`, ge = "https://wa.me/35699578341", pe = {
  lang: "lang",
  action: "action"
}, Ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  baseDomain: A,
  binaryBotProduction: ne,
  binaryBotStaging: oe,
  deriv: h,
  derivAppProduction: ae,
  derivAppStaging: se,
  derivBe: C,
  derivComProduction: M,
  derivComProductionEU: E,
  derivComStaging: ie,
  derivHost: ce,
  derivMe: N,
  derivP2pProduction: ue,
  derivP2pStaging: me,
  domain: i,
  queryParameters: pe,
  smartTraderProduction: de,
  smartTraderStaging: le,
  supportedDomains: U,
  whatsApp: ge
}, Symbol.toStringTag, { value: "Module" })), Se = {
  /**
   * Represents the special characters permitted in an address.
   * @remarks This is to be used in the message of the validation error, to let the user know which characters are permitted.
   * @example `Special characters permitted: ${ValidationConstants.messagesHints.addressPermittedSpecialCharacters}`
   */
  addressPermittedSpecialCharacters: ". , ' : ; ( ) ° @ # / -"
}, Ae = {
  /**
   * @regex /^[\p{L}\p{Nd}\s'’.,:;()\\x{b0}@#/-]{0,70}$/u
   * @description
   * This pattern matches any string with no more than 70 characters, can contain letters, numbers, spaces, and any of the following special characters: '’.,:;()@#/-.
   * @example ValidationConstants.patterns.address.test("123 Main St.")
   * @example ValidationConstants.patterns.address.test("Apt. 123")
   * @example ValidationConstants.patterns.address.test("123 Main St. Apt. 123")
   **/
  address: /^[\p{L}\p{Nd}\s'’.,:;()\\x{b0}@#/-]{0,70}$/u,
  /**
   * @regex /^\p{L}[\p{L}\s'.-]{0,49}$/u
   * @description This pattern matches any string with no more than 50 characters.
   * @example ValidationConstants.patterns.addressCity.test("Main St.")
   * @example ValidationConstants.patterns.addressCity.test("Apt.")
   * @example ValidationConstants.patterns.addressCity.test("Main St. Apt.")
   **/
  addressCity: new RegExp("^\\p{L}[\\p{L}\\s'.-]{0,49}$", "u"),
  /**
   * @regex /^[\p{L}\p{Nd}\s'.,-;]{0,100}$/u
   * @description This pattern matches any string that contains up to 100 characters composed of Unicode letters, Unicode digits, whitespace characters, apostrophes, periods, commas, hyphens, and semicolons ( '.,-;).
   * @example ValidationConstants.patterns.addressState.test("New York")
   * @example ValidationConstants.patterns.addressState.test("Québec")
   **/
  addressState: /^[\p{L}\p{Nd}\s'.,-;]{0,100}$/u,
  /**
   * @regex /^(?=.{1,20}$)[+-]?[0-9]+\.?[0-9]*$/
   * @description This pattern matches any string with 0-9 characters (numeric values. i.e. both integers and floats), and may contain a '+' or '-' sign.
   * @example ValidationConstants.patterns.barrier.test("123")
   * @example ValidationConstants.patterns.barrier.test("123.45")
   * @example ValidationConstants.patterns.barrier.test("-123")
   * @example ValidationConstants.patterns.barrier.test("-123.45")
   * @example ValidationConstants.patterns.barrier.test("+123")
   * @example ValidationConstants.patterns.barrier.test("+123.45")
   */
  barrier: /^(?=.{1,20}$)[+-]?[0-9]+\.?[0-9]*$/,
  /**
   * @regex /^\d*(\.\d+)?$/
   * @description This pattern matches any string that contains only numeric values, and may contain a decimal point.
   * @example ValidationConstants.patterns.decimal.test("123")
   * @example ValidationConstants.patterns.decimal.test("123.45")
   */
  decimal: /^\d*(\.\d+)?$/,
  /**
   * @regex /^\d+$/
   * @description This pattern matches any string that contains only numeric values.
   * @example ValidationConstants.patterns.integer.test("123")
   * @example ValidationConstants.patterns.integer.test("12345")
   */
  integer: /^\d+$/,
  /**
   * @regex /p[.\s]+o[.\s]+box/i
   * @description This pattern matches any string that contains the characters 'p.o.box' or 'p o box'.
   * @example ValidationConstants.patterns.postalOfficeBoxNumber.test("P.O. Box 1234")
   * @example ValidationConstants.patterns.postalOfficeBoxNumber.test("p.o. box 1234")
   * @example ValidationConstants.patterns.postalOfficeBoxNumber.test("P O Box 1234")
   * @example ValidationConstants.patterns.postalOfficeBoxNumber.test("p o box 1234")
   */
  postalOfficeBoxNumber: /p[.\s]+o[.\s]+box/i,
  /**
   * @regex /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/
   * @description This pattern matches any string with 2-63 characters, and contains aplhanumeric characters, an '@' sign, and may also contain any of these characters '+,-._'.
   * @example ValidationConstants.patterns.email.test("doe@meme.me")
   * **/
  email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/,
  /**
   * @regex /^(?=.*[a-z])(?=.*\d)(?=.*[A-Z])[!-~]{8,25}$/
   * @description This pattern matches any string that contains 8-25 characters that include; at least one lowercase letter, at least one digit, at least one uppercase letter, and only printable ASCII characters (from '!' to '~')
   * @example ValidationConstants.patterns.password.test("Password1!")
   **/
  password: /^(?=.*[a-z])(?=.*\d)(?=.*[A-Z])[!-~]{8,25}$/,
  /**
   * @regex /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])[ -~]{6,50}$/
   * @description This pattern matches any string that contains 6-50 characters that include; at least one lowercase letter, at least one digit, at least one uppercase letter, and only printable ASCII characters (from '!' to '~')
   * @example ValidationConstants.patterns.affilliatePassword.test("Password1")
   **/
  affilliatePassword: /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])[ -~]{6,50}$/,
  /**
   * @regex /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,255}$/
   * @description This pattern matches any string with 1-255 characters, and contains aplhanumeric characters, an '@' sign, and may also contain any of these characters '+,-._'.
   * @example ValidationConstants.patterns.paymentAgentEmail.test("doe@meme.us")
   **/
  paymentAgentEmail: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,255}$/,
  /**
   * @regex /^([A-Za-z0-9][A-Za-z0-9\s-]{0,20})?$/
   * @description This pattern matches any string with no more than 20 characters and may not contain '+'.
   * @example ValidationConstants.patterns.postalCode.test("123")
   * @example ValidationConstants.patterns.postalCode.test("123-456")
   **/
  postalCode: /^([A-Za-z0-9][A-Za-z0-9\s-]{0,20})?$/,
  /**
   * @regex /^(?!^$|\s+)[A-Za-z0-9.\/\s-]{0,25}$/
   * @description This pattern matches any string with 0-25 characters, and may contain alphanumeric characters (both uppercase and lowercase), and any of these characters'./-', and or sapce characters
   * @example ValidationConstants.patterns.taxIdentificationNumber.test("123")
   **/
  taxIdentificationNumber: /^(?!^$|\s+)[A-Za-z0-9.\/\s-]{0,25}$/,
  /**
   * @regex /^\+((-|\s)*[0-9]){9,20}$/
   * @description This pattern matches any string that starts with a '+' character, followed by 9-20 digits, allowing hyphens or spaces.
   * @example ValidationConstants.patterns.phoneNumber.test("+1234567890")
   **/
  phoneNumber: /^\+((-|\s)*[0-9]){9,20}$/,
  /**
   * @regex /(image|application)\/(jpe?g|pdf|png)$/
   * @description This pattern matches any of the file types jpeg, jpg, pdf, or png.
   * @example ValidationConstants.patterns.fileType.test("image/jpeg")
   * @example ValidationConstants.patterns.fileType.test("application/pdf")
   * @example ValidationConstants.patterns.fileType.test("image/png")
   * @example ValidationConstants.patterns.fileType.test("image/jpg")
   **/
  fileType: /(image|application)\/(jpe?g|pdf|png)$/,
  /**
   * @regex /(^\d{4})\s(\d{2}X{2})\s(X{4})\s(\d{4}$)/
   * @description This pattern matches any string that's formatted in the following format: 1234 56XX XXXX 1121.
   * @example ValidationConstants.patterns.formattedCardNumber.test("1234 56XX XXXX 1121")
   **/
  formattedCardNumber: /(^\d{4})\s(\d{2}X{2})\s(X{4})\s(\d{4}$)/,
  /**
   * @regex /[^\dX\s]/
   * @description The is pattern matches any string that contains characters that aren't digits, the uppercase letter 'X' and spaces.
   * @example ValidationConstants.patterns.invalidFormattedCardNumberCharacters.test("9876-5432-1098")
   * @example ValidationConstants.patterns.invalidFormattedCardNumberCharacters.test("9876 5432 1098")
   **/
  invalidFormattedCardNumberCharacters: /[^\dX\s]/,
  /**
   * @regex /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*()+\-=\[\]{};':\"|,\.<>\?_~])[ -~]{8,16}$/
   * @description This pattern matches any string that contains 8-16 characters that include; at least one lowercase letter, at least one digit, at least one uppercase letter, and only printable ASCII characters (from '!' to '~')
   * @example ValidationConstants.patterns.tradingPlatformInvestorPassword.test("Password1!$")
   **/
  tradingPlatformInvestorPassword: /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*()+\-=\[\]{};':\"|,\.<>\?_~])[ -~]{8,16}$/,
  /**
   * @regex /^[A-Za-z]+([a-zA-Z.' -])*[a-zA-Z.' -]+$/
   * @description This pattern matches any string that starts with one or more letters (uppercase or lowercase), followed by zero or more occurrences of letters, and any of these characters (.' -) and ends with one or more occurrences of letters, and any of these characters (.' -).
   * @example ValidationConstants.patterns.letterSymbols.test("John Doe")
   * @example ValidationConstants.patterns.letterSymbols.test("John-Doe")
   * @example ValidationConstants.patterns.letterSymbols.test("John O'Doe")
   */
  letterSymbols: /^[A-Za-z]+([a-zA-Z.' -])*[a-zA-Z.' -]+$/,
  /**
   * @regex /^(?!.*\s{2,})(?!\s)[\p{L}\s'.-]{1,50}$/u
   * @description This pattern matches any string that contains 1 to 50 characters, starts and ends with valid characters (letters, whitespace, period, single quote, or hyphen).
   * @example ValidationConstants.patterns.name.test("John Doe")
   * @example ValidationConstants.patterns.name.test("John-Doe")
   * @example ValidationConstants.patterns.name.test("John O'Doe")
   * @example ValidationConstants.patterns.name.test("John O. Doe")
   */
  name: /^(?!.*\s{2,})(?!\s)[\p{L}\s'.-]{1,50}$/u,
  /**
   * @regex /[`~!@#$%^&*)(_=+[}{\]\\/";:?><|]+/
   * @description This pattern matches any string that contains any of these characters: `~!@#$%^&*)(_=+[}{\]\\/";:?><|
   * @example ValidationConstants.patterns.general.test("Password1!")
   */
  general: /[`~!@#$%^&*)(_=+[}{\]\\/";:?><|]+/,
  /**
   * @regex /[a-z]/
   * @description This pattern matches any string that contains lowercase letters.
   * @example ValidationConstants.patterns.lowercase.test("abc")
   */
  lowercase: /[a-z]/,
  /**
   * @regex /\d/
   * @description This pattern matches any string that contains digits.
   * @example ValidationConstants.patterns.number.test("pets123")
   */
  number: /\d/,
  /**
   * @regex /\W/
   * @description This pattern matches any string that contains special characters.
   * @example ValidationConstants.patterns.specialCharacter.test("Password1!")
   */
  specialCharacter: /\W/,
  /**
   * @regex /[A-Z]/
   * @description This pattern matches any string that contains uppercase letters.
   * @example ValidationConstants.patterns.uppercase.test("ABC")
   */
  uppercase: /[A-Z]/,
  /**
   * @regex /^.{8,16}$/
   * @description This pattern matches any string that contains 8-16 characters.
   * @example ValidationConstants.patterns.between8and16Characters.test("Password1!")
   */
  between8and16Characters: /^.{8,16}$/,
  /**
   * @regex /^.{8,25}$/
   * @description This pattern matches any string that contains 8-25 characters.
   * @example ValidationConstants.patterns.between8and25Characters.test("Password1!")
   */
  between8and25Characters: /^.{8,25}$/
}, He = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messagesHints: Se,
  patterns: Ae
}, Symbol.toStringTag, { value: "Module" })), $ = {
  brandName: "Deriv",
  domainName: "Deriv.com"
}, B = {
  fx: "Deriv (FX) Ltd",
  maltainvest: "Deriv Investments (Europe) Limited",
  svg: "Deriv (SVG) LLC",
  v: "Deriv (V) Ltd"
}, j = {
  trader: "Deriv Trader",
  dBot: "Deriv Bot",
  mt5: "Deriv MT5",
  cTrader: "Deriv cTrader",
  derivX: "Deriv X",
  smartTrader: "SmartTrader",
  bBot: "Binary Bot",
  go: "Deriv GO"
}, We = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  brandConfig: $,
  landingCompanies: B,
  platforms: j
}, Symbol.toStringTag, { value: "Module" })), I = /(ALP-|AMN-|ANA-|ANE-|ANG-|AQM-|ARS-|ART-|ATU-|BAC-|BLA-|BRQ-|CAG-|CAM-|CAN-|CAZ-|CDL-|CDY-|CLT-|CRO-|CUN-|DIG-|DRA-|DUA-|DUB-|DVC-|ELE-|ELS-|EML-|EVA-|EVR-|FIG-|FLA-|FRL-|GLK-|HMA-|HW-|HWI-|INE-|JAT-|JEF-|JER-|JKM-|JNY-|JSC-|LDN-|LIO-|LON-|LUA-|LYA-|LYO-|MAR-|MED-|MHA-|MLA-|MRD-|MYA-|NCE-|NEO-|NOH-|NOP-|OCE-|PAR-|PIC-|POT-|PPA-|PRA-|RNE-|SEA-|SLA-|SNE-|SPN-|STK-|TAH-|TAS-|TET-|TRT-|VCE-|VIE-|VKY-|VNS-|VOG-|VTR-|WAS-|WKG-|WLZ-|JAD-|MLD-|RTE-|NAM-|NEN-|BAL-|JLN-|YAL-|MGA-|FGD-|XYAO-|BON-|ALN-|ALT-|BRA-|DBY2-|STG-|MAO-|LEM-|GOA-|FOA-|MNA-|LNA-)/, Ve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  huaweiDevicesRegex: I
}, Symbol.toStringTag, { value: "Module" })), fe = (e, t) => {
  try {
    const { locale: r = "en-US", currency: n, decimalPlaces: o } = t || {}, c = L[n ?? "USD"], d = o ?? c;
    return new Intl.NumberFormat(r, {
      minimumFractionDigits: d,
      maximumFractionDigits: d
    }).format(e);
  } catch {
    return e.toString();
  }
}, Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatMoney: fe
}, Symbol.toStringTag, { value: "Module" })), v = 2560, _e = 0.9, he = 4, F = ({ src: e, filename: t, options: r }) => {
  const { maxWidth: n = v, quality: o = _e } = r || {};
  return new Promise((c, d) => {
    const s = new Image();
    s.src = e, s.onload = () => {
      const a = document.createElement("canvas"), u = a.getContext("2d");
      if (!u || !(u instanceof CanvasRenderingContext2D))
        return d(new Error("Failed to get 2D context"));
      if (s.naturalWidth > n) {
        const m = v, p = m / s.naturalWidth;
        a.width = m, a.height = s.naturalHeight * p;
      } else
        a.width = s.naturalWidth, a.height = s.naturalHeight;
      u.fillStyle = "transparent", u.fillRect(0, 0, a.width, a.height), u.save(), u.drawImage(s, 0, 0, a.width, a.height), a.toBlob(
        (m) => {
          if (!m)
            return;
          const p = t.replace(/\.[^/.]+$/, ".jpg"), S = new Blob([m], { type: "image/jpeg" });
          S.lastModifiedDate = Date.now(), S.name = p, c(S);
        },
        "image/jpeg",
        o
      );
    };
  });
}, G = (e) => new Promise((t) => {
  const r = new FileReader();
  r.readAsDataURL(e), r.onloadend = () => {
    var n;
    t({
      src: ((n = r.result) == null ? void 0 : n.toString()) || "",
      filename: e.name
    });
  };
}), z = (e) => e ? w.some(
  (t) => e.toUpperCase().endsWith(t)
) : !1, De = (e) => new Promise((t) => {
  z(e.name) ? G(e).then((r) => {
    F(r).then(t);
  }) : t(e);
});
function ve(e, t = he) {
  const r = new Uint8Array(t);
  return new DataView(r.buffer).setUint32(0, e), r;
}
const be = (e, {
  chunkSize: t = 16384
  /* 16KB */
}) => {
  const r = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    n % t === 0 ? r.push([o]) : r[r.length - 1].push(o);
  }
  return r.map((n) => new Uint8Array(n)).concat(new Uint8Array([]));
}, Pe = (e) => {
  const t = new FileReader();
  return new Promise((r) => {
    t.onload = () => {
      const n = {
        filename: e.name,
        buffer: t.result,
        fileSize: e.size
      };
      r(n);
    }, t.onerror = () => {
      r({
        message: `Unable to read file ${e.name}`
      });
    }, t.readAsArrayBuffer(e);
  });
}, xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compressImage: F,
  compressImageFile: De,
  convertToBase64: G,
  generateChunks: be,
  isSupportedImageFormat: z,
  numToUint8Array: ve,
  readFile: Pe
}, Symbol.toStringTag, { value: "Module" })), l = (e) => {
  const t = localStorage.getItem(e);
  if (t !== "undefined") {
    if (t === null || t === "null")
      return null;
    try {
      return JSON.parse(t);
    } catch {
      return null;
    }
  }
}, ye = (e, t) => {
  localStorage.setItem(e, JSON.stringify(t));
}, Je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getValue: l,
  setValue: ye
}, Symbol.toStringTag, { value: "Module" })), K = (e) => Object.keys(e).sort().reduce((t, r) => (t[r] = e[r], t), {}), Le = async (e) => {
  const t = new TextEncoder().encode(JSON.stringify(K(e))), r = await crypto.subtle.digest("SHA-256", t);
  return Array.from(new Uint8Array(r)).map((c) => ("00" + c.toString(16)).slice(-2)).join("");
}, Z = (e, t) => Array.isArray(e) && Array.isArray(t) ? t.map((r, n) => Z(e[n], r)) : typeof e == "object" && e !== null && typeof t == "object" && t !== null ? H(e, t) : t, H = (e, ...t) => {
  for (const r of t)
    for (const n in r)
      r[n] === null || r[n] === void 0 || (e[n] = Z(e[n], r[n]));
  return e;
}, ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hashObject: Le,
  merge: H,
  sortObjectByKeys: K
}, Symbol.toStringTag, { value: "Module" }));
function we() {
  let e, t;
  return {
    promise: new Promise((n, o) => {
      e = n, t = o;
    }),
    resolve: e,
    reject: t
  };
}
const Xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPromise: we
}, Symbol.toStringTag, { value: "Module" })), W = () => {
  const t = new URLSearchParams(window.location.search).get("acct1");
  return l(O) || t;
}, V = (e) => e && !/^VR/.test(e) ? "real" : "demo", D = () => {
  const e = l(R);
  if (e)
    return e;
  const t = window.location.hostname, r = y[t];
  return r || "36300";
}, Qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getActiveLoginid: W,
  getAppId: D,
  getEnvironmentFromLoginid: V
}, Symbol.toStringTag, { value: "Module" })), Oe = () => {
  const e = [], t = [], r = new URLSearchParams(window.location.search);
  for (const [o, c] of r.entries()) {
    const d = o.match(/^acct(\d+)/), s = o.match(/^token(\d+)/), a = o.match(/^cur(\d+)/);
    d && (e[+d[1] - 1] = {
      ...e[+d[1] - 1] || {},
      loginid: c
    }), s && (e[+s[1] - 1] = {
      ...e[+s[1] - 1] || {},
      token: c
    }), a && (e[+a[1] - 1] = {
      ...e[+a[1] - 1] || {},
      currency: c
    }), (/acct/.test(o) || /token/.test(o) || /cur/.test(o)) && t.push(o);
  }
  return { loginInfo: e.filter(
    (o) => ["loginid", "token", "currency"].every((c) => Object.keys(o).includes(c))
  ), paramsToDelete: t };
}, Re = (e) => {
  if (e != null && e.length)
    return e.find((t) => /^VR/.test(t.loginid)) || e[0];
}, Te = (e) => {
  const t = new URLSearchParams(window.location.search);
  e.forEach((n) => t.delete(n));
  const r = `${window.location.pathname}${t.toString() ? `?${t.toString()}` : ""}`;
  window.history.pushState(null, "", r);
}, Ne = () => {
  const e = l(g) ?? "EN";
  return `https://oauth.deriv.com/oauth2/authorize?app_id=${D()}&l=${e}&brand=${_}`;
}, Y = () => {
  const e = l(T);
  if (e)
    return e;
  const t = W();
  return P[V(t)];
}, Ce = () => {
  const e = Y(), t = l(g) ?? "EN";
  return `wss://${e}/websockets/v3?app_id=${D()}&l=${t}&brand=${_}`;
}, Ue = (e) => new URLSearchParams(window.location.search).get(e), f = (e) => e.replace(/(^\/|\/$|[^a-zA-Z0-9-_./()#])/g, ""), Me = (e, t) => {
  var o;
  const r = t != null && t.isEU ? E : M;
  let n = ((o = l(g)) == null ? void 0 : o.toLowerCase()) ?? "en";
  return n = n === "en" ? "" : `/${n.replace("_", "-")}`, t != null && t.isDocument ? `${r}/${f(e)}` : `${r}${n}/${f(e)}`;
}, Ee = (e) => /^(((.*)\.)?(localhost:8443|pages.dev|binary\.(sx|com)|deriv.(com|me|be|dev)))$/.test(e), qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  filterSearchParams: Te,
  getDefaultActiveAccount: Re,
  getDerivStaticURL: Me,
  getLoginInfoFromURL: Oe,
  getOauthURL: Ne,
  getQueryParameter: Ue,
  getServerURL: Y,
  getWebsocketURL: Ce,
  isDomainAllowed: Ee,
  normalizePath: f
}, Symbol.toStringTag, { value: "Module" })), $e = (e) => B[e], Be = () => $.domainName, je = (e) => j[e], et = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getBrandWebsiteName: Be,
  getLegalLandingCompany: $e,
  getPlatformName: je
}, Symbol.toStringTag, { value: "Module" })), b = (e) => I.test(e), Ie = async () => {
  const e = window, t = navigator, r = t.userAgent ?? e.opera ?? "";
  if (/windows phone/i.test(r))
    return "Windows Phone";
  if (/android/i.test(r)) {
    if (t.userAgentData) {
      const n = await t.userAgentData.getHighEntropyValues(["model"]);
      if (b((n == null ? void 0 : n.model) || ""))
        return "huawei";
    } else if (b(r) || /huawei/i.test(r))
      return "huawei";
    return "Android";
  }
  return /iPad|iPhone|iPod/.test(r) && !e.MSStream ? "iOS" : "unknown";
}, tt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  mobileOSDetectAsync: Ie
}, Symbol.toStringTag, { value: "Module" }));
export {
  Fe as AppIDConstants,
  We as BrandConstants,
  et as BrandUtils,
  Ge as CurrencyConstants,
  ze as DocumentConstants,
  Ye as FormatUtils,
  xe as ImageUtils,
  Ke as LocalStorageConstants,
  Je as LocalStorageUtils,
  Ve as MobileDevicesConstants,
  tt as OSDetectionUtils,
  ke as ObjectUtils,
  Xe as PromiseUtils,
  Ze as URLConstants,
  qe as URLUtils,
  He as ValidationConstants,
  Qe as WebSocketUtils
};
